module.exports = __webpack_public_path__ + "img/icon2.3d554b58.png";